import { MoovDefinitionCustomerAdoptionDTO } from "../DTO/moovDefinitionCustomerAdoptionDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateMoovDefinitioncustomerAdoptionRequest extends BasicRequest{
   
    public moovDefinitionCustomerAdoption! : MoovDefinitionCustomerAdoptionDTO;
    
    constructor(){
        super()
    }
}